import { render } from "./TheCreateButton.vue?vue&type=template&id=259ce04f"
import script from "./TheCreateButton.vue?vue&type=script&lang=js"
export * from "./TheCreateButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__